import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class LogsService {

    static getLogs(page, maxPerPage, CompanyCode, LogLevel, Channel, WebNode, startdate, enddate, email) {
        //var data = [];
        return axios.get(`${BaseUrl}Log?page=${page}&maxPerPage=${maxPerPage}&CompanyCode=${CompanyCode ? CompanyCode : ''}` +
            `&LogLevel=${LogLevel ? LogLevel : ''}&Channel=${Channel ? Channel : ''}&WebNode=${WebNode ? WebNode : ''}` +
            `&startdate=${startdate ? startdate : ''}&enddate=${enddate ? enddate : ''}&email=${email ? email : ''}`);
    }

    static getAllChannel() {
        //var data = [];
        return axios.get(`${BaseUrl}Channel`);
    }
    static getAllWebNode() {
        //var data = [];
        return axios.get(`${BaseUrl}WebNode`);
    }


    static getAllCompany(startdate, enddate) {
        //var data = [];
        return axios.get(`${BaseUrl}CompanyTotalLog?startdate=${startdate ? startdate : ''}&enddate=${enddate ? enddate : ''}`);
    }


}


// WEBPACK FOOTER //
// ./src/Services/LogService/logService.js